import { ReactElement } from 'react';
import { Message } from '@messageformat/react';
import { space } from '@op/opds.tokens';
import { Col, Row } from '@op/opds.opux';
import TextComponent from '../TextComponent';
import { ReactComponent as Image29 } from '../../images/OP_symbolikuvitus_128_029.svg';
import StockPieChart from './StockPieChart';
import AssetClassReturnsGraph from './AssetClassReturnsGraph';
import TaskOne from './TaskOne';
import BankrupcyGraph from './BankrupcyGraph';
import MSCIGraph from './MSCIGraph/MSCIGraph';
import DispersionGraph from './DispersionGraph/DispersionGraph';
import IndustrySpecificGraph from './IndustrySpecificGraph/IndustrySpecificGraph';
import ProfitAndRiskGraphs from './ProfitAndRiskGraphs/ProfitAndRiskGraphs';
import CourseHeader from '../CourseHeader';
import InfoTextBox from './InfoTextBox';
import CourseComplete from '../CourseComplete';
import InterestGraph1 from './InterestGraph/InterestGraph1';
import InterestGraph2 from './InterestGraph/InterestGraph2';
import InterestGraph3 from './InterestGraph/InterestGraph3';

const Course2 = (): ReactElement => {
  return (
    <div style={{ marginBottom: space.default }}>
      <CourseHeader
        courseTitleId="course2.title"
        courseHeaderText="how_to_start"
        Image={Image29}
        courseNumber={2}
      />
      <Row style={{ paddingBottom: space.xl, margin: 0 }}>
        <Col md={6} xs={12} className="investoracademy-multi-column-left">
          <p className="investoracademy-text-paragraph">
            <Message id="course2.introduction.part1" />
          </p>
          <InfoTextBox />
        </Col>
        <Col md={6} xs={12} className="investoracademy-multi-column-right">
          <p className="investoracademy-text-paragraph">
            <Message id="course2.introduction.part2" />
          </p>
          <p className="investoracademy-text-paragraph">
            <Message id="course2.introduction.part3" />
          </p>
        </Col>
      </Row>
      <div className="investoracademy-number" aria-hidden="true">
        1
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`1. `}</span>
        <Message id="course2.part1.title" />
      </h2>
      <TextComponent messageId="course2.part1.body1" twoColumns />
      <ProfitAndRiskGraphs />
      <TextComponent messageId="course2.part1.body2" twoColumns />
      <div
        className="investoracademy-number"
        aria-hidden="true"
        style={{
          paddingTop: space.large,
        }}
      >
        2
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`2. `}</span>
        <Message id="course2.part2.title" />
      </h2>
      <TextComponent messageId="course2.part2.body1" twoColumns headingAs="h3" />
      <BankrupcyGraph />
      <TextComponent messageId="course2.part2.body2" twoColumns headingAs="h3" />
      <DispersionGraph />
      <TextComponent messageId="course2.part2.body3" twoColumns headingAs="h3" />
      <StockPieChart />
      <TextComponent messageId="course2.part2.body4" twoColumns headingAs="h3" />
      <IndustrySpecificGraph />
      <TextComponent messageId="course2.part2.body5" twoColumns headingAs="h3" />
      <AssetClassReturnsGraph />
      <div className="investoracademy-number" aria-hidden="true">
        3
      </div>
      <h2
        className="opds-styles-v1-text-hero-small"
        style={{
          textAlign: 'center',
          paddingBottom: space.default,
          paddingTop: space.small,
        }}
      >
        <span className="sr-only">{`3. `}</span>
        <Message id="course2.part3.title" />
      </h2>
      <p className="investoracademy-text-paragraph">
        <Message id="course2.part3.body1" />
      </p>
      <MSCIGraph />

      <TextComponent messageId="course2.part3.body2" twoColumns />
      <h3
        className="opds-styles-v1-text-title-large"
        style={{ textAlign: 'center', marginBottom: space.default }}
      >
        <Message id="course2.part3.title3" />
      </h3>
      <p
        className="investoracademy-text-paragraph"
        style={{
          textAlign: 'center',
        }}
      >
        <Message id="course2.part3.body3" />
      </p>
      <InterestGraph1 />
      <InterestGraph2 />
      <InterestGraph3 />
      <div style={{ marginBottom: space.xxl, textAlign: 'center' }}>
        <TextComponent messageId="course2.part3.body4" twoColumns={false} />
      </div>
      <TaskOne />
      <CourseComplete messageId="course2.recap" />
    </div>
  );
};

export default Course2;
